import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

const ScrollReveal = ({ children, threshold = 0.1, triggerOnce = true, ...props }) => {
  const { ref, inView } = useInView({
    triggerOnce,
    threshold,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 50 }}
      transition={{ duration: 1, ease: 'easeOut' }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
